module.exports = __webpack_public_path__ + "static/media/bitkeep.1fd67c87.png";